import React, { useState, ChangeEvent } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'; 

interface InputFieldProps {
  placeholder: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  value:string;
}

const InputField: React.FC<InputFieldProps> = ({ placeholder, onChange,value }) => {
  // State to toggle password visibility
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  // Handler to toggle password visibility
  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };

  return (
    <div className="relative w-[90%]">
      <input
        type={isPasswordVisible ? "text" : "password"} // Toggle between text and password
        className="border-b-2 border-black focus:outline-none placeholder:text-left placeholder:text-gray-500 w-[98%] text-xl"
        name="name"
        placeholder={placeholder}
        onChange={onChange}
        value={value}
      />
      <button
        type="button"
        onClick={togglePasswordVisibility}
        className="absolute inset-y-0 right-0 flex items-center px-2 text-gray-500"
      >
        {isPasswordVisible ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
      </button>
    </div>
  );
}

export default InputField;
